import { gql } from '@apollo/client';

/**
 * 查询账单汇总任务进度
 */
export const GET_BILL_SUMMARY_PROGRESS = gql`
  query GetBillSummaryProgress($taskId: ID!) {
    getBillSummaryProgress(taskId: $taskId) {
      taskId
      status
      progress
      currentStep
      summaryCount
      totalAmount
      errorMessage
    }
  }
`;

/**
 * 查询账单汇总历史
 */
export const GET_BILL_SUMMARY_HISTORY = gql`
  query GetBillSummaryHistory($billId: ID!) {
    getBillSummaryHistory(billId: $billId) {
      id
      billId
      operatorName
      status
      progress
      currentStep
      summaryCount
      totalAmount
      createdAt
      completedAt
      errorMessage
    }
  }
`;

